import React, {useMemo} from 'react'
import {StandAloneAppLayout} from '@komune-io/g2-layout'
import {MenuItems} from '@komune-io/g2-components'
import {useExtendedAuth} from "@tracabois/connect";
import {useTranslation} from "react-i18next";
import { makeG2STyles } from '@komune-io/g2-themes';

makeG2STyles()(
    () => ({
      "AruiHeader-root": {
        padding: "16px 60px!important"
      }
    }))

interface PlatformLayoutProps {
    children?: React.ReactNode
    menu: MenuItems[],
    loggedMenu: MenuItems[],
    notLoggedMenu: MenuItems[],
    logo: string,
    website: string,
}

export const PlatformLayout = (props: PlatformLayoutProps) => {
    const { children, menu, logo, loggedMenu, notLoggedMenu, website } = props
    const { t } = useTranslation()
    const { service } = useExtendedAuth()
    const user = useMemo(() => {
        return {
            person: service.getUser(),
            role: service.getUserPrincipalRole()
        }
    }, [service.getUser])

    const handleLogoClick = () => {
        window.open(website,'_blank');
    }
    return (
        <StandAloneAppLayout
            logo ={{src: logo, imgProps:{onClick: handleLogoClick}, item: {componentProps: {sx: {"& .MuiListItemIcon-root": {width: "100%"}, "& img": {width: "100%"}, "&:hover": {backgroundColor: "transparent"}}}}}}
            menu={menu}
            userMenuProps={{
                currentUser: user ? {
                    givenName: user.person?.firstName ?? "",
                    familyName: user.person?.lastName ?? "",
                    role: t("roles." + user.role)
                } : undefined,
                loggedMenu: loggedMenu,
                notLoggedMenu: notLoggedMenu,
                defaultOpen: false,
            }}
        >
            {children}
        </StandAloneAppLayout>
    )
}

